import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { resolveImage } from '../config';

const TopSalesCard = ({ product }) => {
  const { dispatch, items } = useCart();
  const [added, setAdded] = useState(false);
  const hasVariants = product.variantsCount > 0;
  const inCart = items.find(i => i.id === product.id);
  const rating = Number(product.rating) || 0;

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (hasVariants) return;
    dispatch({ type: 'ADD_ITEM', payload: { ...product, price: parseFloat(product.price) || 0 } });
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <Link to={`/product/${product.id}`} className="top-sale-card">
      <div className="top-sale-card__img-wrap">
        <img src={resolveImage(product.image)} alt={product.name} loading="lazy" />
      </div>
      <div className="top-sale-card__body">
        <h3 className="top-sale-card__name">{product.name}</h3>
        <div className="top-sale-card__rating">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <span key={i} className={i < Math.floor(rating) ? 'star star--full' : 'star star--empty'}>★</span>
            ))}
          </div>
          <span className="top-sale-card__rating-score">{rating.toFixed(1)}</span>
        </div>
        <div className="top-sale-card__footer">
          <strong className="top-sale-card__price">{Number(product.price).toLocaleString()} TND</strong>
          {hasVariants ? (
            <span className="top-sale-card__add" aria-label="Voir les modèles">→</span>
          ) : (
            <button
              type="button"
              className={`top-sale-card__add ${added ? 'top-sale-card__add--added' : ''}`}
              onClick={handleAdd}
              aria-label={added ? 'Ajouté' : inCart ? 'Déjà au panier' : 'Ajouter au panier'}
            >
              {added ? '✓' : '+'}
            </button>
          )}
        </div>
      </div>
    </Link>
  );
};

export default TopSalesCard;
